import React from "react";
import Reveal from "../../../components/ui/Reveal";

export default function SectionTitle({
  eyebrow,
  title,
  highlight,
  subtitle,
  align = "center",
}) {
  const alignment =
    align === "left"
      ? "text-left items-start"
      : "text-center items-center mx-auto";

  return (
    <Reveal className={`max-w-3xl mb-10 flex flex-col ${alignment}`}>
      {eyebrow && (
        <span className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.25em] text-primary dark:bg-primary/15">
          {eyebrow}
        </span>
      )}

      <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-slate-950 dark:text-white sm:text-4xl lg:text-5xl">
        {title}
        {highlight && (
          <span className="bg-gradient-to-r from-primary to-emerald-500 bg-clip-text text-transparent">
            {highlight}
          </span>
        )}
      </h2>

      {subtitle && (
        <p className="mt-4 text-base leading-7 text-slate-600 dark:text-slate-300 sm:text-lg">
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}